import React, { useState } from 'react';
import { Box, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { useL10n } from '@uplift/hooks';
import { Button } from '@uplift/ui-v2';
import { UserContact } from '@uplift/types';
import { BetterhelpSsoButton } from './betterhelp-sso-button.component';
import { LoginForm } from './login-form.component';


const useStyles = makeStyles()((theme) => ({
  choice: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(5),
  },
  credentials: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonWrapper: {
    width: '100%',
    maxWidth: '510px',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    maxWidth: '432px',
  },
  divider: {
    width: '100%',
    maxWidth: '510px',
    margin: theme.spacing(3, 0),
  },
}));


type LoginStepperProps = {
  isBetterhelpSsoEnabled: boolean;
  onSubmit: (redirectUrl: string, code: string) => void;
  onCheckEmail: (email: string) => void;
  onMfaChallenge: (userId: string, email: string, contacts: UserContact[], requestId: string) => void;
};

export const LoginStepper: React.VFC<LoginStepperProps> = ({
  isBetterhelpSsoEnabled,
  onSubmit,
  onCheckEmail,
  onMfaChallenge,
}) => {
  const { classes } = useStyles();
  const l10n = useL10n();
  const [ step, setStep ] = useState<'choice' | 'credentials'>('choice');

  if (isBetterhelpSsoEnabled && step === 'choice') {
    return (
      <Box className={classes.choice}>
        <BetterhelpSsoButton variant="contained" />
        <Box className={classes.buttonWrapper}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => setStep('credentials')}
            className={classes.button}
          >
            {l10n.auth.logInWithEmail}
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={classes.credentials}>
      {isBetterhelpSsoEnabled && (
        <>
          <BetterhelpSsoButton variant="outlined" />
          <Divider className={classes.divider}>or</Divider>
        </>
      )}
      <LoginForm
        onSubmit={onSubmit}
        onCheckEmail={onCheckEmail}
        onMfaChallenge={onMfaChallenge}
      />
    </Box>
  );
};
